var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.type === 'campaign' ? 'campaign-wrap' : 'summary-wrap'},[_c('iframe',{attrs:{"scrolling":"no","id":this.type === 'campaign' ? 'campaign-iframe_wrapper' : 'iframe_wrapper',"src":_vm.createUrl(this.label),"frameborder":0}})])
}
var staticRenderFns = []

export { render, staticRenderFns }